import {ACTION} from './constants';
import request from '../../../../utils/request';
import {requestConfig} from "../../../../config/apiResource";
import {hideMainLoader,showMainLoader} from "../../../actions";

export function getStaticPageContent(serverData,pageType) {
    if(serverData.url){
        let type = serverData.url.split('/')[1];
        pageType = type;
    }
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getStaticPageContent(pageType))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_STATIC_PAGE_CONTENT , data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with static page data: " + error)
            });
    }
}



